export enum WarehouseTransferMethod {
  GET_WAREHOUSE_TRANSFER_PRODUCT = 'get-warehouse-transfer-product',
}
